<template>
  <div class="monitor-item" v-on="$listeners" v-bind="$attrs">
    <circle-icon :icon="icon" :bg="bg" :color="color" size="lg"></circle-icon>
    <div class="val">{{ val }}</div>
    <div class="label">{{ label }}</div>
    <div v-if="extent" class="extent" :class="{ up: up }">
      <i :class="upIcon"></i><span>{{ extent }}</span>
    </div>
    <div v-if="tip" class="tip">
      <el-popover placement="top-start" trigger="hover" :content="tip">
        <i class="el-icon-question" slot="reference"></i>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monitor-item',
  props: {
    icon: {
      type: String,
      required: true,
    },
    bg: {
      type: String,
      default: '#fff7e6',
    },
    color: {
      type: String,
      default: '#ffa940',
    },
    value: [String, Number],
    label: String,
    up: {
      /*箭头方向*/ type: Boolean,
      default: false,
    },
    extent: String /*涨跌数值*/,
    tip: String,
  },
  computed: {
    upIcon() {
      return this.up ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    },
    val() {
      if (!this.value && this.value != 0) {
        return '0'
      }
      if (this.value < 1000) {
        return this.value + ''
      } else if (this.value < 1000000) {
        return (this.value / 1000).toFixed(1) + 'K'
      } else {
        return (this.value / 1000000).toFixed(1) + 'M'
      }
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.monitor-item {
  position: relative;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  text-align: center;

  .val {
    font-size: 28px;
    font-weight: 700;
    margin: 8px 0 4px;
    line-height: 1.5;
    color: #515a6e;
  }
  .label {
    color: #808695;
    font-size: 12px;
  }
  .extent {
    height: 25px;
    margin-top: 10px;
    font-weight: 700;
    font-size: 14px;

    color: #19be6b;

    i {
      margin-right: 4px;
    }

    &.up {
      color: #ed4014;
    }
  }
  .tip {
    font-size: 14px;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #808695;
  }
}
</style>